import utils from '@/modules/utils';

const _dataStore = {
  backendBaseUrl: BACKEND_HOST,
  loadedResources: {},
  loadedUrls: {},
  splashScreen:{},
  resourceUrls: null,
  reportName: null
};

function assertInitialized() {
  if (!_dataStore.reportName || !_dataStore.resourceUrls)
    utils.redirect.notFound();
}

function getRawResource(filename, cb) {
  assertInitialized();

  if (_dataStore.loadedResources[filename]) {
    cb(_dataStore.loadedResources[filename], _dataStore.loadedUrls[filename]);
  } else {
    _dataStore.isInitialized.then((initStatus) => {
      _dataStore.splashScreen.loading = true;

      var url_path = _dataStore.resourceUrls[filename];
      $.get(url_path, function(data) {
        _dataStore.loadedResources[filename] = data;
        _dataStore.loadedUrls[filename] = url_path;
        _dataStore.splashScreen.loading = false;
        cb(data, url_path);
      });
    });
  }
}

const DataStore = {
  /**
   * Datastore that will fetch data using the same syntax as d3.
   * Every time data is fetched, it will be stored so it won't have to be fetched again.
   * Usage examples:
   * DataStore.csv("audience_analysis_geo_data.csv", function(csv) { ... }) // fetching csv data
   * DataStore.json("audience_analysis_geo_tree.json", function(json) { ... }) // fetching json data
   */
  init(reportName) {
    if (_dataStore.reportName)
      throw new Error('DataStore already initialized with a report name');

    _dataStore.reportName = reportName;

    _dataStore.isInitialized = new Promise((resolve, reject) => {
      $.ajax({
        url: _dataStore.backendBaseUrl + '/reports/' + reportName,
        dataType: 'json',
        async: false,
        success: function(data) {
          _dataStore.resourceUrls = data.files;
          resolve(true);
        },
        error: function(xhr) {
          if (xhr.status == 404) {
            utils.redirect.notFound();
          } else {
            utils.redirect.internalServerError();
          }
        }
      });

    });

  },

  isInitialized() {
    return _dataStore.isInitialized;
  },

  setSplashScreenControl(splashScreen) {
    _dataStore.splashScreen = splashScreen;
  },

  csv(filename, cb) {
    getRawResource(filename, function(data) {
      cb(d3.csv.parse(data));
    });
  },

  json(filename, cb) {
    getRawResource(filename, function(data) {
      cb(JSON.parse(data));
    });
  },

  raw(filename, cb) {
    getRawResource(filename, function(data, url_path) {
      cb(data, url_path)
    });
  }
}

Object.freeze(DataStore);
export default DataStore;



// WEBPACK FOOTER //
// ./src/modules/DataStore.js